import { useMutation } from "@tanstack/react-query";
import { useI18n } from "i18n";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import { Errors, trackError } from "modules/monitoring";
import { CompanySettingErrors } from "../../constants";
import useCompanySettingsActions from "../useCompanySettingsActions";
import request from "./request";

const useUpdateDisableVPNCheck = (companyId?: string) => {
  const { addErrorNotification, addSuccessNotification } =
    useNotificationActions();
  const { setCompanySettings } = useCompanySettingsActions();
  const { t } = useI18n(["settings"]);

  const { mutate } = useMutation({
    mutationFn: async (disableVPNCheck: boolean) => {
      if (!companyId) {
        throw new Error(CompanySettingErrors.NO_COMPANY_ID);
      }

      return request(companyId, disableVPNCheck);
    },

    onSuccess: (companySettings) => {
      setCompanySettings(companySettings);

      addSuccessNotification({
        message: t("update.disable.vpn.check.success"),
        position: "tc",
      });
    },

    onError: (error: Error, _) => {
      trackError(error, {
        label: Errors.DISABLE_VPN_CHECK_UPDATE,
        companyId,
      });
      addErrorNotification({
        message: t("update.disable.vpn.check.error"),
        position: "tc",
      });
    },
  });

  return { updateDisableVPNCheck: mutate };
};

export default useUpdateDisableVPNCheck;
